import React from "react";

const Sinopsis = () => {
  return (
    <div className="container-sinopsis">
      <p>
        La Luna y La Lunita que te Parió son dos espectáculos teatrales que
        brindan herramientas de autoconocimiento. Hablamos sobre la salud
        emocional desde la cosmovisión astrológica, para enriquecer el
        desarrollo psico-espiritual del ser humano.
      </p>
      <p>
        <b>La Luna que te Parió</b> es una obra para adultos y pone sobre la
        mesa los 12 comportamientos destructivos que nos separan, nos dejan
        sufrientes y aislados.
      </p>
      <p>
        <b>La Lunita que te Parió</b> es para niños, familias, educadores y todo
        aquel que esté en sintonía con la crianza y la educación, aborda los 12
        poderes constructivos y creadores de la rueda del zodíaco.
      </p>
      <p>
        En ambas obras hay 13 actores que van recorriendo los signos zodiacales
        (de Aries a Piscis) y cuentan con intervenciones poéticas para personas
        sordas.
      </p>
    </div>
  );
};

export default Sinopsis;
